import { render, staticRenderFns } from "./AdminForm.vue?vue&type=template&id=ba49115a&"
import script from "./AdminForm.vue?vue&type=script&lang=js&"
export * from "./AdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba49115a')) {
      api.createRecord('ba49115a', component.options)
    } else {
      api.reload('ba49115a', component.options)
    }
    module.hot.accept("./AdminForm.vue?vue&type=template&id=ba49115a&", function () {
      api.rerender('ba49115a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/AdminForm.vue"
export default component.exports